<template>
  <div class="cs-qr">
    <div class="cs-qr__info">
      <!-- <div class="cs-qr__coin-box" v-if="anyWalletCoin">
        <img
          v-if="anyWalletCoin.logo"
          :src="anyWalletCoin.logo"
          alt="coin icon"
          class="cs-qr__icon"
        />
        <div class="cs-qr__name">
          {{ anyWalletCoin.name }}
        </div>
      </div> -->
    </div>
    <h4 class="scan-qr">{{ $t("qr-code.scan-code") }}</h4>
    <!-- {{ anyWalletCoin }} -->
    <b-link
      href="#"
      class="w-100 instructions-list"
      :class="showInstructionsDropdown ? null : 'collapsed'"
      aria-controls="collapse-4"
      @click="toggleDetailedInstructions"
      >Detailed Instructions
      <img
        :src="
          !showInstructionsDropdown
            ? require('@/assets/img/down-arrow1.svg')
            : require('@/assets/img/down-arrow2.svg')
        "
        alt="toggle instructions"
      />
    </b-link>
    <b-collapse
      id="collapse-4"
      v-model:open="showInstructionsDropdown"
      class="mt-2"
    >
      <div class="instructions details ml-n3">
        <InstructionsList :anyWalletCoin="anyWalletCoin" :store="store" />
      </div>
    </b-collapse>
    <template v-if="showInstructionsDropdown == false">
      <div class="cs-qramoountbox text-center">
        <div class="cs-qr__amount" v-if="payableData.payable_amount">
          <!-- <div class="cs-qr__amount" v-if="payableAmount || (qrData && qrData.nativeAmount)"> -->
          <!-- Already using USD -->
          <!-- {{NumberFormat(DecimalNumber
          (qrData.nativeAmount).div(
            conversionRate2.currentRate))}} -->
          <span>
            {{ NumberFormat(payableData.payable_amount) }}
          </span>
          <span class="d-inline">
            {{
              payableData.payable_currency && !anyWalletError
                ? payableData.payable_currency == "USDT"
                  ? "USDT(ERC20)"
                  : payableData.payable_currency
                : ""
            }}
            <!-- <img :src="anyWalletCoin.chainsNetworkLogo" id="chainsNetworkLogo"
           class="d-inline chainsNetworkLogo"/>
          <b-tooltip
          target="chainsNetworkLogo"
           placement="top"
          class="text-capitalize "
        >
        <span class="text-capitalize d-block">Currency: {{anyWalletCoin.currency}}</span>
         <span class="text-capitalize">Network: {{anyWalletCoin.chainNetwork}}</span>
        </b-tooltip> -->
          </span>
          <h4 class="px-3 lh-5" v-if="payableData.stableCoinProcessingFee">
            <span class="text-dark p-1 text-center">
              {{
                "(includes " +
                payableData.stableCoinProcessingFee +
                " " +
                payableData.payable_currency +
                " processing fee)"
              }}
            </span>
          </h4>
          <h4 class="px-3 d-flex" v-if="anyWalletCoin.networkMsg != ''">
            <img
              src="@/assets/img/info_blue.svg"
              id="titlePartial"
              alt="info"
              class="infoIcon mx-2"
            />
            <span class="text-dark p-1 text-left"
              >{{ anyWalletCoin.networkMsg }}
            </span>
          </h4>
        </div>
        <div class="cs-qr__amount" v-else>- - -</div>
        <div class="text-center m-auto">
          <div v-if="qrData && qrData.meta" class="text-center m-auto">
            <vue-qr
              :style="isCodeExpired ? { opacity: 0.1 } : {}"
              v-if="qrData && qrData.meta"
              :text="qrData.meta ? qrData.meta.qrString : ''"
              class="cs-qr__code"
            />
            <div class="cs-qr__code border" v-else>
              <Loading />
            </div>
          </div>
          <div
            class="cs-qr__code mx-auto d-flex justify-content-center align-items-center"
            v-else
          >
            <Loading />
          </div>
        </div>
      </div>
      <div :class="!qrData || !qrData.meta ? 'disable-events' : ''">
        <div class="" v-if="qrData && qrData.meta">
          <div
            class="cs-qrcopybox mx-auto d-flex justify-content-between align-items-center"
          >
            <span class="ml-2">
              {{
                qrData.meta && qrData.meta.receiverAddress
                  ? ShortText(qrData.meta.receiverAddress, 10)
                  : ""
              }}</span
            >
            <div
              v-if="!isCodeExpired"
              v-clipboard="qrData.meta.receiverAddress"
              v-clipboard:success="ClipboardSuccessHandler"
              @click.prevent="handleCopyClick"
              class="btn copy-btn"
            >
              <img
                v-if="!isCopied"
                src="@/assets/img/Copy_alt.svg"
                alt="copy"
              />
              <span v-if="isCopied" class="copied-message">Copied</span>
            </div>
          </div>
          <!-- <div class="cs-qr__hr"></div>
          <div class="mx-2 cs-qr__or">or</div>
          <div class="cs-qr__hr"></div> -->
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <!-- <button
            v-if="!isCodeExpired"
            v-clipboard:copy="
              qrData.meta ? getReceiverAddress(qrData.meta.receiverAddress) : ''
            "
            :style="!qrData || !qrData.meta ? 'background:grey; opacity:0.5' : ''"
            class="cs-qr__copy"
            :class="{ 'cs-qr__copy_success': saved }"
            @click="copySuccess()"
          >
            {{ $t("unauth-payment.copy-address") }}
          </button> -->
          <!-- <button
            v-if="qrData.meta && getTag(qrData.meta.receiverAddress)"
            v-clipboard:copy="
              qrData.meta ? getTag(qrData.meta.receiverAddress) : ''
            "
            class="cs-qr__copy mt-1 ml-3"
            :class="{ 'cs-qr__copy_success': saved }"
            @click="copySuccess()"
          >
            Copy Tag
          </button> -->
        </div>
      </div>

      <b-modal
        v-model="isCodeExpiredVar"
        centered
        hide-header
        hide-footer
        no-close-on-backdrop
      >
        <h5>{{ $t("qr-expired.title") }}</h5>
        <p class="text-left mb-1">{{ $t("qr-expired.desc1") }}</p>
        <p class="text-left">
          {{ $t("qr-expired.description") }}
          <a :href="shopperUrl" target="_blank">Portal here</a>.
        </p>
      </b-modal>
    </template>

    <b-modal v-model="isInstructions" centered hide-header hide-footer>
      <div class="instructions first-instructions ml-n3">
        <InstructionsList :anyWalletCoin="anyWalletCoin" :store="store" />
        <div class="d-flex flex-row align-items-center">
          <input
            :checked="isInstructionsRepeated ? true : false"
            type="checkbox"
            class="checkbox"
            @click="doNotRepeatInstructions($event)"
          />
          <div class="mt-1">Do not show this again?</div>
        </div>
      </div>
      <div class="text-center mt-1">
        <b-button
          size="sm"
          class="footer-btn cursor-pointer w-25 ok-btn"
          @click="closeInstructions"
        >
          <b>{{ $t("popup-modal.ok") }}</b>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from "vuex";
/* eslint-disable global-require */

import Loading from "@/components/Loading.vue";
import InstructionsList from "@/components/CryptoWallet/InstructionsList.vue";
import { USER_TRACK_EVENTS } from "@/store/modules/user/consts";

export default {
  components: {
    Loading,
    InstructionsList,
  },
  props: {
    qrData: Object || {},
    anyWalletCoin: Object || {},
    anyWalletError: String || "",
    convertedCart: Object || {},
    displayCurrency: Object || {},
    currencies: Array || [],
    isPreview: Boolean,
    payableData: Object || {},
    isCodeExpired: Boolean,
    isContinuedTransaction: Boolean,
  },
  computed: {
    ...mapGetters({
      paymentOptions: "user/paymentOptions",
      store: "user/marketInfo",
    }),
    conversionRate2() {
      let rate = {};
      this.currencies.forEach((item) => {
        if (this.anyWalletCoin?.currency) {
          if (
            item.id.toLowerCase() === this.anyWalletCoin.currency.toLowerCase()
          ) {
            rate = item;
          }
        }
      });
      return rate;
    },
  },
  data() {
    return {
      shopperUrl: process.env.VUE_APP_SHOPPER_URL,
      saved: false,
      isInstructions: false,
      showInstructionsDropdown: false,
      isInstructionsRepeated: false,
      isCodeExpiredVar: false,
      isCopied: false,
      currentSession: false
    };
  },
  watch: {
    allPaymentTabs() {
      this.init();
    },
    isCodeExpired(val) {
      this.isCodeExpiredVar = val;
    },
  },
  mounted() {
    this.init();
    this.isInstructionsRepeated =
      this.$DbStorage.getItem("doNotRepeatInstructions") === "true";
      this.currentSession = (this.$DbStorage.getItem('currentSessionInstructions') === 'true');
    if (
      !this.isInstructionsRepeated &&
      !this.isContinuedTransaction &&
      !this.isCodeExpired && !this.currentSession
    ) {
      this.isInstructions = true;
      this.$DbStorage.setItem('currentSessionInstructions', 'true');
    }
  },
  methods: {
    toggleDetailedInstructions() {
      this.showInstructionsDropdown = !this.showInstructionsDropdown;

      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: "Crypto Wallet tab",
          activity: `detailed instructions ${
            this.showInstructionsDropdown ? "opened" : "closed"
          }`,
        },
      });
    },
    handleCopyClick(event) {
      // Prevent the default click behavior
      event.preventDefault();

      const isSuccess = true;

      if (isSuccess) {
        // Set isCopied to true to show the "Copied" message
        this.isCopied = true;

        // Reset isCopied after a delay (e.g., 2 seconds)
        setTimeout(() => {
          this.isCopied = false;
        }, 2000);
      }
    },
    ClipboardSuccessHandler(value) {
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: "Crypto Wallet tab",
          activity: `clicked on copy button, Wallet Address copied.`,
        },
      });
    },
    closeIframe() {
      this.notifyParentWindow({
        type: "rocketfuel_iframe_close",
        paymentCompleted: false,
      });
    },
    doNotRepeatInstructions(val) {
      this.$DbStorage.setItem("doNotRepeatInstructions", val.target.checked);
    },
    copySuccess() {
      this.saved = true;
      setTimeout(() => {
        this.saved = false;
      }, 500);
    },
    init() {},
    getReceiverAddress(address) {
      if (address.split(":::ucl:::").length > 1) {
        return address.split(":::ucl:::")[0];
      }
      return address;
    },
    closeInstructions() {
      this.isInstructions = false;
      window.EventBus.emit(`startCountdown`);
    },
    showInstructions() {
      this.isInstructions = true;
    },
    getTag(address) {
      if (address.split(":::ucl:::").length > 1) {
        return address.split(":::ucl:::")[1];
      }
      return null;
    },
    ShortText(text, size) {
      if (!text) {
        return `-`;
      }
      if (size) {
        return `${text.slice(0, size)}...${text.slice(-size)}`;
      }
      if (text.length > 25 && !size) {
        return `${text.slice(0, 25)}...`;
      }
      return text;
    },
  },
};
</script>
<style lang="scss" scoped>
#tip {
  float: right;
  margin-top: 8px;
  cursor: pointer;
}

.footer-btn {
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px 10px;
  color: #303030 !important;
}

.footer-btn-2 {
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px 10px;
  color: white !important;
}

.cs-qr {
  // border: 1px solid $border;
  // border-radius: 1px;
  // display: flex;
  // padding: 5px;
  justify-content: center;
  align-items: center;
  &__code {
    width: 200px;
    min-width: 120px;
    height: 200px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 10px;
  }

  &__coin-box {
    display: flex;
    align-items: center;
    margin: 10px 0;
  }

  &__icon {
    width: 21px;
    min-width: 21px;
    height: 21px;
    object-fit: contain;
    border-radius: 50%;
    margin-right: 10px;
  }

  &__name {
    font-size: 14px;
    line-height: 17px;
  }

  &__amount {
    font-weight: 900;
    font-size: 24px;
    line-height: 21px;
    margin-top: 10px;
  }

  &__convert {
    font-weight: 300;
    font-size: 14px;
    line-height: 23px;
    color: $black400;
    margin-bottom: 8px;
  }

  &__hr {
    width: 10%;
    height: 1px;
    background-color: #888786;
  }

  &__or {
    font-size: 12px;
    color: #888786;
  }

  &__copy {
    width: 120px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #5559fe;
    border: 1px solid #5559fe;
    border-radius: 1px;
    font-size: 12px;
    line-height: 23px;
    color: $white;
    transition: 0.3s;
    //transform: translateX(96px);
    margin-bottom: 10px;
    margin-top: 6px;
    text-transform: uppercase;
    &:hover {
      border-color: #5559fe;
      color: #5559fe;
      background-color: $white;
    }
    &_success {
      border-color: $green500 !important;
      color: $green500 !important;
    }
  }

  &__infoText {
    display: flex;
    padding: 7px 8px;
    border-radius: 4px;
    color: #7e7e7e;
    background-color: #f2f2f2;
    line-height: 15px;
    font-size: 13px;
    div {
      margin-right: 4px;
      img {
        width: 20px;
        margin-top: 1px;
        margin-right: 5px;
      }
      ol {
        padding: 0px 0px 0px 15px;
        margin-bottom: 0px;
        font-size: 12px;
        line-height: 18px;
      }
    }
  }
}
.cs-qr {
  h4 {
    font-weight: 500;
    font-size: 12px;
    line-height: 19px;
    color: #5559fe;
    margin: 10px -15px;
    text-align: center;
  }
}

.expired-overlay {
  background: #ffffff;
  box-shadow: 0px 5px 5px #ddd;
  padding: 10px;
  margin: 0px 20px 0px 10px;
  border-radius: 10px;
  text-align: center;
  color: black;
  position: absolute;

  h5 {
    font-size: 15px;
    text-decoration: underline;
  }

  p {
    font-size: 14px;
  }
}

.instruction-note {
  line-height: 1.7;
  font-size: 12px;
  margin-left: 25px !important;
  font-weight: 500;
}

.checkbox {
  margin: 0px 10px -2px 25px !important;
  font-size: 14px;
  cursor: pointer !important;
}

.disable-events {
  pointer-events: none !important;
}

.cs-qramoountbox {
  border: 1px solid rgba(0, 0, 0, 0.4);
  width: 275px;
  margin: 10px auto;
}
.cs-qrcopybox {
  border: 1px solid rgba(0, 0, 0, 0.4);
  width: 275px;
  margin: -10px auto auto 10px;
}
.instructions-list {
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  text-decoration-line: underline;
  color: #000000;
  text-align: center;

  img {
    display: inline-block;
  }
}
.first-instructions.instructions {
  color: #000000;
  letter-spacing: 0em;
  text-align: left;
  font-size: 13px;
  background: #ffffff;
}
.details.instructions {
  color: #000000;
  letter-spacing: 0em;
  text-align: left;
  font-size: 13px;
  z-index: 1;
  padding: 5px;
  width: 95%;
  background: #ffffff;
}

::v-deep(.collapse) {
  max-height: none !important;
}

.ok-btn {
  color: white !important;
}
.chainsNetworkLogo {
  width: 20px;
}
.copy-btn {
  margin-left: 4px;
  cursor: pointer;
}
.infoIcon {
  margin-top: -2.3em;
}
.scan-qr {
  margin: 10px -25px !important;
}
.lh-5 {
  line-height: 5px !important;
}

.copied-message {
  font-size: 14px;
  max-width: 100%;
  display: block;
}
</style>
